<ng-container *ngIf="(loading$ | async) === false; else loadingTemplate">
  <div
    *ngIf="company"
    class="grid mb-5">
    <div class="lg:col-6 col-12">
      <p-card header="Компания">
        <div class="p-fluid">
          <div class="field">
            <label class="font-medium">Тип компании</label>
            <crm-single-select
              [options]="jurisdictions"
              [(selectedItem)]="company.jurisdiction"
              (selectedItemChange)="company.allDocumentTypesAllowed = true"
              [isTemplateCombined]="true"
              [filter]="false"
              optionValue="name"
              [class]="errors?.jurisdiction ? 'ng-invalid ng-dirty' : ''"
              [styleClass]="errors?.jurisdiction ? 'ng-invalid ng-dirty' : ''">
              <ng-template
                #itemTemplate
                let-type="item">
                {{ type.value | jurisdictionType }}
              </ng-template>
            </crm-single-select>
            <small
              *ngIf="errors?.jurisdiction"
              class="p-error">
              {{ errors.jurisdiction | join }}
            </small>
          </div>

          <div
            *ngIf="company.jurisdiction !== JurisdictionTypeEnum.FOREIGN"
            class="field">
            <label class="font-medium required-field">ИНН</label>
            <crm-inn-auto-complete
              [isError]="$any(errors?.inn)"
              [(selectedPerson)]="person"
              (selectedPersonChange)="selectedPerson($event)"
              [persons]="persons"
              (personSearch)="searchParson($event)"></crm-inn-auto-complete>
            <small
              *ngIf="errors?.inn"
              class="p-error">
              {{ errors.inn | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium required-field">Название компании</label>
            <crm-input-text
              [(value)]="company.name"
              [isError]="$any(errors?.name)"></crm-input-text>
            <small
              *ngIf="errors?.name"
              class="p-error">
              {{ errors.name | join }}
            </small>
          </div>

          <div class="formgrid grid">
            <div class="field col">
              <label class="font-medium required-field">Тип</label>
              <crm-single-select
                optionValue="name"
                [options]="personTypes"
                [isTemplateCombined]="true"
                [filter]="false"
                [(selectedItem)]="company.personType"
                [class]="errors?.personType ? 'ng-invalid ng-dirty' : ''"
                [styleClass]="errors?.personType ? 'ng-invalid ng-dirty' : ''">
                <ng-template
                  #itemTemplate
                  let-type="item">
                  {{ type.value | personTypeName }}
                </ng-template>
              </crm-single-select>
              <small
                *ngIf="errors?.personType"
                class="p-error">
                {{ errors.personType | join }}
              </small>
            </div>

            <div class="field col">
              <label class="font-medium">Группа</label>
              <crm-single-select
                [options]="groups"
                [(selectedItem)]="company.group"
                [class]="errors?.group ? 'ng-invalid ng-dirty' : ''">
              </crm-single-select>
              <small
                *ngIf="errors?.group"
                class="p-error">
                {{ errors.group | join }}
              </small>
            </div>
          </div>

          <div class="field">
            <label class="font-medium">Генеральный директор</label>
            <crm-input-text
              [(value)]="company.manager"
              [isError]="$any(errors?.manager)"></crm-input-text>
            <small
              *ngIf="errors?.manager"
              class="p-error">
              {{ errors.manager | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium">Генеральный директор (Родительный Падеж)</label>
            <crm-input-text
              [(value)]="company.genitiveManager"
              [isError]="$any(errors?.genitiveManager)"></crm-input-text>
            <small
              *ngIf="errors?.genitiveManager"
              class="p-error">
              {{ errors.genitiveManager | join }}
            </small>
          </div>

          <div class="formgrid grid">
            <div class="field col">
              <label class="font-medium">Email</label>
              <crm-input-text
                [(value)]="company.email"
                [isError]="$any(errors?.email)"></crm-input-text>
              <small
                *ngIf="errors?.email"
                class="p-error">
                {{ errors.email | join }}
              </small>
            </div>

            <div class="field col">
              <label class="font-medium">Телефон</label>
              <p-inputMask
                type="text"
                mask="+9 (999) 999-99-99"
                placeholder="+7 (999) 999-99-99"
                [unmask]="true"
                [(ngModel)]="company.phone"
                name="phone"></p-inputMask>
              <small
                *ngIf="errors?.phone"
                class="p-error">
                {{ errors.phone | join }}
              </small>
            </div>
          </div>

          <div class="field">
            <label class="font-medium">Сайт</label>
            <div class="p-inputgroup crm-hex-inputgroup">
              <span class="p-inputgroup-addon">https://</span>
              <crm-input-text
                [(value)]="company.website"
                [isError]="$any(errors?.website)"
                class="w-full"></crm-input-text>
            </div>
            <small
              *ngIf="errors?.website"
              class="p-error">
              {{ errors.website | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium">Юридический адрес</label>
            <crm-input-text
              [(value)]="company.address"
              [isError]="$any(errors?.address)"></crm-input-text>
            <small
              *ngIf="errors?.address"
              class="p-error">
              {{ errors.address | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium">Фактический адрес</label>
            <crm-input-text
              [(value)]="company.postAddress"
              [isError]="$any(errors?.postAddress)"></crm-input-text>
            <small
              *ngIf="errors?.postAddress"
              class="p-error">
              {{ errors.postAddress | join }}
            </small>
          </div>

          <ng-container *ngIf="company.jurisdiction !== JurisdictionTypeEnum.FOREIGN">
            <div class="formgrid grid">
              <div class="field col-6">
                <label class="font-medium">КПП</label>
                <crm-input-text
                  [(value)]="company.kpp"
                  [isError]="$any(errors?.kpp)"></crm-input-text>
                <small
                  *ngIf="errors?.kpp"
                  class="p-error">
                  {{ errors.kpp | join }}
                </small>
              </div>

              <div class="field col-6">
                <label class="font-medium">ОГРН</label>
                <crm-input-text
                  [(value)]="company.ogrn"
                  [isError]="$any(errors?.ogrn)"></crm-input-text>
                <small
                  *ngIf="errors?.ogrn"
                  class="p-error">
                  {{ errors.ogrn | join }}
                </small>
              </div>

              <div class="field col-6">
                <label class="font-medium">База 1С</label>
                <div class="flex gap-1">
                  <crm-database-single-select
                    [databases]="databases"
                    [(selectedDatabase)]="company.connection"
                    styleClass="w-full"
                    class="w-full"
                    [class]="errors?.connection ? 'ng-invalid ng-dirty' : ''">
                  </crm-database-single-select>
                  <crm-button
                    *ngIf="canWriteCompanyErp1C"
                    icon="pi pi-plus"
                    styleClass="p-button-info"
                    pTooltip="Добавить новую Базу 1С"
                    tooltipPosition="top"
                    (onClick)="showDialogCreate1C()">
                  </crm-button>
                </div>
                <small
                  *ngIf="errors?.connection"
                  class="p-error">
                  {{ errors.connection | join }}
                </small>
              </div>

              <div class="field col-6">
                <label class="font-medium">Налогообложение</label>
                <crm-taxation-single-select
                  [class]="errors?.taxationType ? 'ng-invalid ng-dirty' : ''"
                  [styleClass]="errors?.taxationType ? 'ng-invalid ng-dirty' : ''"
                  [(selectedTaxation)]="company.taxationType">
                </crm-taxation-single-select>
                <small
                  *ngIf="errors?.taxationType"
                  class="p-error">
                  {{ errors.taxationType | join }}
                </small>
              </div>
            </div>
          </ng-container>

          <div
            *ngIf="company.jurisdiction === JurisdictionTypeEnum.FOREIGN && canWriteCompanyErp1C"
            class="field">
            <label class="font-medium">База 1С</label>
            <div class="flex gap-1">
              <crm-database-single-select
                [databases]="databases"
                [(selectedDatabase)]="company.connection"
                styleClass="w-full"
                class="w-full"
                [class]="errors?.connection ? 'ng-invalid ng-dirty' : ''">
              </crm-database-single-select>
              <crm-button
                icon="pi pi-plus"
                styleClass="p-button-info"
                pTooltip="Добавить новую Базу 1С"
                tooltipPosition="top"
                (onClick)="showDialogCreate1C()">
              </crm-button>
            </div>
            <small
              *ngIf="errors?.connection"
              class="p-error">
              {{ errors.connection | join }}
            </small>
          </div>

          <div class="field-checkbox mb-0 col-12">
            <p-checkbox
              [(ngModel)]="company.allDocumentTypesAllowed"
              [binary]="true"
              inputId="allDocumentTypesAllowed"></p-checkbox>
            <label [for]="'allDocumentTypesAllowed'">Изменение всех типов документов</label>
          </div>
        </div>
      </p-card>
    </div>

    <div class="lg:col-6 col-12">
      <p-card header="Валюта">
        <div class="p-fluid">
          <div class="field">
            <label class="font-medium">Валюта</label>
            <crm-currency-multi-select
              [(selectedEntities)]="company.currencies"
              [isError]="$any(errors?.currencies)"
              (selectedEntitiesChange)="selectCurrencies()"
              appendTo="body"></crm-currency-multi-select>
            <small
              *ngIf="errors?.currencies"
              class="p-error">
              {{ errors.currencies | join }}
            </small>
          </div>

          <div
            *ngIf="company.currencies?.length"
            class="field">
            <crm-table
              styleClass="card-table p-datatable-sm p-datatable-gridlines"
              sort="name:string"
              [columns]="columns"
              [values]="company.currencies">
              <ng-template
                #rowTemplate
                let-currency="item">
                <tr *ngIf="toCurrency(currency) as currency">
                  <td>
                    {{ currency?.name }}
                  </td>
                  <td>
                    <p-checkbox
                      [(ngModel)]="currency.isDefault"
                      [binary]="true"
                      (ngModelChange)="setDefaultCurrency(currency, $event)"></p-checkbox>
                  </td>
                </tr>
              </ng-template>
            </crm-table>
          </div></div
      ></p-card>

      <div class="mt-3">
        <crm-table-bank-details
          [(bankDetails)]="company.bankDetails"
          [jurisdiction]="company.jurisdiction"
          [banks]="banks"
          [showDefaultBankDetail]="true"
          [showPaymentsViaBank]="true"
          [errors]="$any(errors?.bankDetails)"
          (bankSearch)="searchBank($event)">
        </crm-table-bank-details>
      </div>
    </div>
  </div>

  <div class="grid mt-3">
    <div class="lg:col-6 col-12 flex flex-wrap justify-content-between">
      <crm-button
        [label]="saveButtonLabel"
        styleClass="p-button-success mr-2"
        (onClick)="saveCompany()"></crm-button>
      <crm-button
        *ngIf="(form$ | async)?.isShowDelete"
        label="Удалить"
        styleClass="p-button-danger p-button-text"
        (onClick)="deleteCompany()"></crm-button>
    </div>
  </div>
</ng-container>

<ng-template #loadingTemplate>
  <crm-spinner></crm-spinner>
</ng-template>
